<app-breadcrumb [title]="'Setting'"></app-breadcrumb>
<div class="container-fluid mt--6">
  <div class="row">
    <div class="col">
      <div class="card mb-3">
        <div class="card-header bg-white">
          <div class="d-flex justify-content-between">
            <h3 class="h6 fw-bold mb-0">{{ title }}</h3>
            <a [routerLink]="['/admin/regions/states/districts/schools']"
              class="btn btn-sm btn-outline-primary">Cancel</a>
          </div>
        </div>
        <div class="card-body">

          <form [formGroup]="settingForm" (ngSubmit)="save()">
            <input type="hidden" formControlName="id">
            <input type="hidden" formControlName="assiCommSignId">

            <div class="row">
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label for="financialYearId">Financial Year</label>
                  <select MyInput formControlName="financialYearId" class="form-select">
                    <option value="" selected>--SELECT--</option>
                    <option *ngFor="let item of financialYears" value="{{ item.value }}">{{ item.text }}
                    </option>
                  </select>
                  <my-error controlName="financialYearId" errorKey="required">Financial Year is required.</my-error>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label for="phaseId">Phase</label>
                  <select MyInput formControlName="phaseId" class="form-select">
                    <option value="" selected>--SELECT--</option>
                    <option *ngFor="let item of phases" value="{{ item.value }}">{{ item.text }}
                    </option>
                  </select>
                  <my-error controlName="phaseId" errorKey="required">Phase is required.</my-error>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-3 form-check">
                  <input type="checkbox" MyInput formControlName="isProfile" class="form-check-input" id="isProfile">
                  <label class="form-check-label" for="isProfile">Active Profile Update for Employee?</label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-3 form-check">
                  <input type="checkbox" MyInput formControlName="isProfilePrincipal" class="form-check-input"
                    id="isProfilePrincipal">
                  <label class="form-check-label" for="isProfilePrincipal">Active Profile Approval Module for
                    Principal?</label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-3 form-check">
                  <input type="checkbox" MyInput formControlName="isProfileRO" class="form-check-input"
                    id="isProfileRO">
                  <label class="form-check-label" for="isProfileRO">Active Profile Approval Module for RO?</label>
                </div>
              </div>
            </div>


            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-3 form-check">
                  <input type="checkbox" MyInput formControlName="isTransfer" class="form-check-input" id="isTransfer">
                  <label class="form-check-label" for="isTransfer">Active Request Transfer?</label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-3 form-check">
                  <input type="checkbox" MyInput formControlName="isTransferPrincipal" class="form-check-input"
                    id="isTransferPrincipal">
                  <label class="form-check-label" for="isTransferPrincipal">Active Request Transfer for
                    Principal?</label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-3 form-check">
                  <input type="checkbox" MyInput formControlName="isTransferRO" class="form-check-input"
                    id="isTransferRO">
                  <label class="form-check-label" for="isTransferRO">Active Request Transfer for RO?</label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-3 form-check">
                  <input type="checkbox" MyInput formControlName="isVacancyEmp" class="form-check-input"
                    id="isVacancyEmp">
                  <label class="form-check-label" for="isVacancyEmp">Active Vacancy Module for Employee ?</label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-3 form-check">
                  <input type="checkbox" MyInput formControlName="isVacancyPrincipal" class="form-check-input"
                    id="isVacancyPrincipal">
                  <label class="form-check-label" for="isVacancyPrincipal">Active Vacancy Module for Principal ?</label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-3 form-check">
                  <input type="checkbox" MyInput formControlName="isVacancyRO" class="form-check-input"
                    id="isVacancyRO">
                  <label class="form-check-label" for="isVacancyRO">Active Vacancy Module for RO ?</label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-3 form-check">
                  <input type="checkbox" MyInput formControlName="isEmpLoginClose" class="form-check-input"
                    id="isEmpLoginClose">
                  <label class="form-check-label" for="isEmpLoginClose">Active Employee Login ?</label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-3 form-check">
                  <input type="checkbox" MyInput formControlName="isROLoginClose" class="form-check-input"
                    id="isROLoginClose">
                  <label class="form-check-label" for="isROLoginClose">Active RO Employee Login ?</label>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-3 form-check">
                  <input type="checkbox" MyInput formControlName="isPrincipalLoginClose" class="form-check-input"
                    id="isPrincipalLoginClose">
                  <label class="form-check-label" for="isPrincipalLoginClose">Active Principal Employee Login ?</label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label for="assiCommName">Assi. Comm. Name</label>
                  <textarea MyInput formControlName="assiCommName" class="form-control" rows="2"></textarea>
                  <my-error controlName="assiCommName" errorKey="required">Assi. Comm. Name is required.</my-error>
                </div>
              </div>
              <div class="col-md-4">
                <label class="form-label" for="cutOfDate">Cut Of Date</label>
                <div class="input-group">
                  <span class="input-group-text">
                    <i-bs name="calendar3" width="1em" height="1em"></i-bs>
                  </span>
                  <input MyInput formControlName="cutOfDate" placeholder="dd-mm-yyyy"
                    class="form-control form-control-sm datepicker" ngbDatepicker #cutOfDate="ngbDatepicker"
                    (click)="cutOfDate.toggle()" />
                </div>
                <my-error controlName="cutOfDate" errorKey="required">From is required.</my-error>
              </div>
              <!-- <div class="col-md-4">
                <label class="form-label" for="previousYearCutOfDate"> Previous Year Cut Of Date</label>
                <div class="input-group">
                  <span class="input-group-text">
                    <i-bs name="calendar3" width="1em" height="1em"></i-bs>
                  </span>
                  <input MyInput formControlName="previousYearCutOfDate" placeholder="dd-mm-yyyy"
                    class="form-control form-control-sm datepicker" ngbDatepicker #previousYearCutOfDate="ngbDatepicker"
                    (click)="previousYearCutOfDate.toggle()" />
                </div>
                <my-error controlName="previousYearCutOfDate" errorKey="required">From is required.</my-error>
              </div> -->
            </div>

            <div class="border p-2">
              <div class="row">
                <div class="col-md-12">
                  <label class="form-label" for="customFile">Assi. Comm. Sign.</label>
                </div>
                <div class="col-md-4">
                  <input class="form-control" type="file" #inputDoc
                    (change)="handleFileInput($event.target.files);OnSubmit(inputDoc)">
                  <my-error controlName="assiCommSignId" errorKey="required">Sign is required.</my-error>
                </div>
                <div class="col-md-4" *ngIf="setting?.assiCommSign">
                  <a target="_blank" [attr.href]="setting.assiCommSign?.mediaUrl"
                    class="btn btn-success btn-sm">Uploaded
                    Sign</a>
                </div>
              </div>
              <div id="progress-avatar" class="progress progress-xs" [class.fade]="!isProgress">
                <div [style.width]="barWidth + '%'"
                  class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar"
                  aria-valuemin="0" aria-valuemax="100"></div>
              </div>
            </div>

            <div class="d-flex justify-content-end mt-5">
              <button class="btn btn-primary rounded-0 ml-auto mr-2" [disabled]="!settingForm.valid || loading"
                type="submit">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="loading"></span>
                Submit
              </button>
            </div>
          </form>

        </div>
      </div>

    </div>
  </div>
</div>